/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S7_P3Inputs */

const en_guide_large_json_files_s7_p3 = /** @type {(inputs: Guide_Large_Json_Files_S7_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For human readability, the trick is to avoid rendering the whole thing at once. A collapsible tree view lets you open only the branch you care about, and searching for a key is faster than scrolling. Because these tools run in your browser, even a large file never leaves your machine while you explore it.`)
};

const ko_guide_large_json_files_s7_p3 = /** @type {(inputs: Guide_Large_Json_Files_S7_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사람이 읽는 문제라면, 전체를 한 번에 그리지 않는 것이 요령입니다. 접을 수 있는 트리 뷰는 원하는 가지만 펼치게 해주고, 키를 검색하는 것이 스크롤보다 빠릅니다. 이 도구들은 브라우저에서 실행되므로 큰 파일도 탐색하는 동안 기기를 떠나지 않습니다.`)
};

const ja_guide_large_json_files_s7_p3 = /** @type {(inputs: Guide_Large_Json_Files_S7_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人が読む問題なら、全体を一度に描画しないのがコツです。折りたためるツリービューは必要な枝だけを開かせてくれ、キーを検索するほうがスクロールより速いです。これらのツールはブラウザ内で動くので、大きなファイルでも探索している間に端末を離れることはありません。`)
};

/**
* | output |
* | --- |
* | "For human readability, the trick is to avoid rendering the whole thing at once. A collapsible tree view lets you open only the branch you care about, and sea..." |
*
* @param {Guide_Large_Json_Files_S7_P3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s7_p3 = /** @type {((inputs?: Guide_Large_Json_Files_S7_P3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S7_P3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s7_p3(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s7_p3(inputs)
	return ja_guide_large_json_files_s7_p3(inputs)
});